export var MuiInputBaseProps = {};
// unused now, not deleting yet
export var getMuiInputBaseOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        root: {
            fontSize: '1rem',
        },
        input: {
            paddingTop: spacing(1),
            paddingBottom: spacing(1),
            paddingLeft: spacing(2),
            paddingRight: spacing(2),
            height: 'auto',
            boxSizing: 'border-box',
            fontSize: 'inherit',
            backgroundColor: palette.common.white,
        },
    });
};
//# sourceMappingURL=MuiInputBase.js.map